import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ProtectedRouteProps {
  requiresAuth: boolean;
  isConfigured: boolean;
  children: ReactNode;
}

export default function ProtectedRoute(
  { requiresAuth, isConfigured, children }: ProtectedRouteProps,
) {
  const { t } = useTranslation(["auth"]);
  const location = useLocation();

  if (!requiresAuth) {
    return <>{children}</>;
  }

  if (isConfigured) {
    // Remember where the user was going (path + query, e.g. an invite token)
    // so the post-login redirect at /login can send them back instead of
    // dropping them on the home page.
    return (
      <Navigate
        to="/login"
        replace
        state={{ next: location.pathname + location.search }}
      />
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-center text-muted-foreground">
      <h2 className="text-xl font-semibold text-foreground">
        {t("auth:firebase.notConfigured")}
      </h2>
      <p className="mt-2">
        {t("auth:firebase.notConfiguredMessage")}
      </p>
    </div>
  );
}
